<template>
  <div class="map-controls">
    <!-- Zoom In -->
    <button class="ctrl-btn" title="Zoom In" @click="$emit('zoom-in')">
      <v-icon size="18" color="#374151">mdi-plus</v-icon>
    </button>

    <!-- Zoom Out -->
    <button class="ctrl-btn" title="Zoom Out" @click="$emit('zoom-out')">
      <v-icon size="18" color="#374151">mdi-minus</v-icon>
    </button>

    <div class="ctrl-divider"></div>

    <!-- Fit Bounds -->
    <button
      v-if="config.fitBounds !== false"
      class="ctrl-btn"
      title="Fit all markers"
      @click="$emit('fit-bounds')"
    >
      <v-icon size="18" color="#374151">mdi-fit-to-page-outline</v-icon>
    </button>

    <!-- Satellite Toggle -->
    <button
      v-if="config.satellite !== false"
      class="ctrl-btn"
      :class="{ active: satelliteActive }"
      title="Toggle satellite view"
      @click="toggleSatellite"
    >
      <v-icon size="18" :color="satelliteActive ? '#de520c' : '#374151'">mdi-satellite-variant</v-icon>
    </button>

    <!-- Fullscreen -->
    <button
      v-if="config.fullscreen !== false"
      class="ctrl-btn"
      :title="isFullscreen ? 'Exit fullscreen' : 'Fullscreen'"
      @click="toggleFullscreen"
    >
      <v-icon size="18" color="#374151">
        {{ isFullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}
      </v-icon>
    </button>
  </div>
</template>

<script>
export default {
  name: 'MapControls',
  props: {
    config: {
      type:    Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      satelliteActive: false,
      isFullscreen:    false,
    };
  },
  methods: {
    toggleSatellite() {
      this.satelliteActive = !this.satelliteActive;
      this.$emit('tile-change', this.satelliteActive ? 'satellite' : 'osm');
    },
    toggleFullscreen() {
      const el = this.$el.closest('.base-leaflet-map');
      if (!document.fullscreenElement) {
        if (el && el.requestFullscreen) {
          el.requestFullscreen();
          this.isFullscreen = true;
        }
      } else {
        document.exitFullscreen();
        this.isFullscreen = false;
      }
    },
  },
};
</script>

<style scoped>
.map-controls {
  position: absolute;
  top: 16px;
  right: 304px; /* right of filter panel */
  z-index: 1200;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-radius: 10px;
  padding: 6px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.6);
}

.ctrl-btn {
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  border-radius: 7px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.14s;
}
.ctrl-btn:hover {
  background: #f3f4f6;
}
.ctrl-btn.active {
  background: rgba(222, 82, 12, 0.1);
}

.ctrl-divider {
  height: 1px;
  background: #e5e7eb;
  margin: 2px 0;
}

@media (max-width: 960px) {
  .map-controls {
    right: 16px;
    top: 66px;
    flex-direction: row;
  }
}
</style>
